import { Ace } from '@assets/vendor/ace-builds/ace';

// ENUMS #######################################################################
export enum CodeEditorPanelIdentifierEnum {
	PRIMARY = 'panelPrimary',
	SECONDARY = 'panelSecondary'
}

export enum SplitViewOrientationEnum {
	LEFT_RIGHT = 'leftRight',
	TOP_BOTTOM = 'topBottom'
}

// INTERFACES ##################################################################
export interface ICodeEditorPanel {
	config: CodeEditorPanelConfigType;
	aceEditorInstance?: Ace.Editor;
}

export interface ICodeEditorConfig {
	allowSyntaxHighlighting?: boolean;
	theme?: string;
	[ CodeEditorPanelIdentifierEnum.PRIMARY ]: ICodeEditorPrimaryPanelConfig;
	[ CodeEditorPanelIdentifierEnum.SECONDARY ]?: ICodeEditorSecondaryPanelConfig;
}

export interface ICodeEditorFooterConfig {
	showFooter: boolean;
}

export interface ICodeEditorHeaderConfig {
	renderEditorCloseButton?: boolean;
	showHeader: boolean;
	titleI18nPath?: string;
}

export interface ICodeEditorPanelBaseConfig {
	isReadonly?: boolean;
	header: ICodeEditorHeaderConfig;
}

export interface ICodeEditorPrimaryPanelConfig extends ICodeEditorPanelBaseConfig {
	identifier: CodeEditorPanelIdentifierEnum.PRIMARY;
}

export interface ICodeEditorSecondaryPanelConfig extends ICodeEditorPanelBaseConfig {
	identifier: CodeEditorPanelIdentifierEnum.SECONDARY;
	splitView: {
		orientation?: SplitViewOrientationEnum;
		synchronizeScrollbars?: boolean;
	};
}

// TYPES #######################################################################
export type CodeEditorPanelConfigType = ICodeEditorPrimaryPanelConfig | ICodeEditorSecondaryPanelConfig;

